import type { RouteRecordRaw } from "vue-router";

export const businessCenterRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/businessCenter/businessManage",
		name: "BusinessManage",
		meta: {
			title: "组织管理",
			keepAlive: false,
		},
		component: () => import("@main/views/Apps/BusinessCenter/BusinessManage/BusinessManage.vue"),
	},
	{
		path: "/desktopCenter/businessCenter/organizationalStructure",
		name: "OrganizationalStructure",
		meta: {
			title: "组织架构",
			keepAlive: false,
		},
		redirect: "/desktopCenter/businessCenter/organizationalStructure/memberManage",
		children: [
			{
				path: "/desktopCenter/businessCenter/organizationalStructure/memberManage",
				name: "MemberManage",
				meta: {
					title: "成员管理",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/BusinessCenter/OrganizationalStructure/MemberManage/MemberManage.vue"
					),
			},
			{
				path: "/desktopCenter/businessCenter/organizationalStructure/departmentalManage",
				name: "DepartmentalManage",
				meta: {
					title: "部门管理",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/BusinessCenter/OrganizationalStructure/DepartmentalManage/DepartmentalManage.vue"
					),
			},
			{
				path: "/desktopCenter/businessCenter/organizationalStructure/positionManage",
				name: "PositionManage",
				meta: {
					title: "职位管理",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/BusinessCenter/OrganizationalStructure/PositionManage/PositionManage.vue"
					),
			},
			{
				path: "/desktopCenter/businessCenter/organizationalStructure/affiliatedOrganizations",
				name: "AffiliatedOrganizations",
				meta: {
					title: "附属组织",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/BusinessCenter/OrganizationalStructure/AffiliatedOrganizations/AffiliatedOrganizations.vue"
					),
			},
		],
	},
	{
		path: "/desktopCenter/businessCenter/organizationInformation",
		name: "OrganizationInformation",
		meta: {
			title: "组织信息",
			keepAlive: false,
		},
		redirect: "/desktopCenter/businessCenter/organizationInformation/organizationBasicInformation",
		children: [
			{
				path: "/desktopCenter/businessCenter/organizationInformation/organizationBasicInformation",
				name: "OrganizationBasicInformation",
				meta: {
					title: "基本信息",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/business/association/index",
				},
				component: () =>
					import(
						"@main/views/Apps/BusinessCenter/OrganizationInformation/OrganizationBasicInformation/OrganizationBasicInformation.vue"
					),
			},
			{
				path: "/desktopCenter/businessCenter/organizationInformation/qualificationCertificates",
				name: "QualificationCertificates",
				meta: {
					title: "资质证件",
					keepAlive: false,
				},
				component: () =>
					import(
						"@main/views/Apps/BusinessCenter/OrganizationInformation/QualificationCertificates/QualificationCertificates.vue"
					),
			},
			{
				path: "/desktopCenter/businessCenter/organizationInformation/certificatesHonors",
				name: "CertificatesHonors",
				meta: {
					title: "证书荣誉",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/member/cert",
				},
				component: () =>
					import(
						"@main/views/Apps/BusinessCenter/OrganizationInformation/CertificatesHonors/CertificatesHonors.vue"
					),
			},
			{
				path: "/desktopCenter/businessCenter/organizationInformation/albumManage",
				name: "AlbumManage",
				meta: {
					title: "相册管理",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/album",
				},
				component: () =>
					import(
						"@main/views/Apps/BusinessCenter/OrganizationInformation/AlbumManage/AlbumManage.vue"
					),
			},
		],
	},
	{
		path: "/desktopCenter/businessCenter/permissionManage",
		name: "BusinessPermissionManage",
		meta: {
			title: "权限管理",
			keepAlive: false,
		},
		redirect: "/desktopCenter/businessCenter/permissionManage/roleManage",
		children: [
			{
				path: "/desktopCenter/businessCenter/permissionManage/roleManage",
				name: "RoleManage",
				meta: {
					title: "角色管理",
					keepAlive: false,
				},
				component: () =>
					import("@main/views/Apps/BusinessCenter/PermissionManage/RoleManage/RoleManage.vue"),
			},
		],
	},
];
